export const instagramProfile = {
    username: 'dnystu',
    url: 'https://www.instagram.com/dnystu/',
    image: '/images/instagram/profile.webp',
};

// Homepage Instagram grid. To change it: drop a photo in public/images/instagram/,
// then add or reorder an entry here with that file and the Instagram post URL.
const instagramPosts = [
    {
        id: 'DIhjMm_Ty4U',
        permalink: 'https://www.instagram.com/p/DIhjMm_Ty4U/',
        image: '/images/instagram/DIhjMm_Ty4U.jpg',
        caption: '‘hug’\n\ninspired by the beautiful and vibrant san diegan printmaking community\n\nedition of 12 cards\n\nfeeling incredibly grateful to share my love of printmaking for event by @athenaeumartcenter alongside @kelvinlopezstudio and @idonthaveagram\n\nswing by saturday, may 3rd',
        timestamp: '2025-04-16',
    },
    {
        id: 'C3pX6o0LHj9',
        permalink: 'https://www.instagram.com/p/C3pX6o0LHj9/',
        image: '/images/instagram/C3pX6o0LHj9.jpg',
        caption: '‘shoreline’ 2023\n10”x12” photogravure with digital chine colle\n\nfuji film taken from the salton sea c. 2019\nan oldie but a goodie',
        timestamp: '2024-02-22',
    },
    {
        id: 'Cugo6xcOzmK',
        permalink: 'https://www.instagram.com/p/Cugo6xcOzmK/',
        image: '/images/instagram/Cugo6xcOzmK.jpg',
        caption: 'wharf (2022)\nphotogravure\n10”-12”\n\na personal favorite of mine, digital collage work incorporating my family overlooking beacons c. 1982.',
        timestamp: '2023-07-10',
    },
    {
        id: 'CugoTY1uH0m',
        permalink: 'https://www.instagram.com/p/CugoTY1uH0m/',
        image: '/images/instagram/CugoTY1uH0m.jpg',
        caption: 'japanese lotus (2023)\nCMYK separation screen print\n15”-22”',
        timestamp: '2023-07-10',
    },
    {
        id: 'ClvQEyDu_yF',
        permalink: 'https://www.instagram.com/p/ClvQEyDu_yF/',
        image: '/images/instagram/ClvQEyDu_yF.jpg',
        caption: 'one leg quail',
        timestamp: '2022-12-04',
    },
    {
        id: 'CkIhDehr20b',
        permalink: 'https://www.instagram.com/p/CkIhDehr20b/',
        image: '/images/instagram/CkIhDehr20b.jpg',
        caption: 'go slugs! lithographic print.',
        timestamp: '2022-10-25',
    },
];

export default instagramPosts;
